import React from "react";
import { MainBodyContainer } from "../../../widget/common/ui/MainContainer";
import AppTranslation from "../../../service/app_translation/AppTranslation";
import DashboardLayout from "../../dashboard/DashboardLayout";
import NoticesListActions from "./widget/NoticesListActions";
import { NoticesListContextProvider } from "../../../provider/notices/notices_list/NoticesListContextProvider";
import NoticesListContent from "./NoticesListContent";

const NoticesListScreen = () => {
  return (
    <NoticesListContextProvider>
      <DashboardLayout
        title={AppTranslation.text("notices")}
        navIndex={3}
        actions={<NoticesListActions />}
      >
        <MainBodyContainer className="h-100">
          <NoticesListContent />
        </MainBodyContainer>
      </DashboardLayout>
    </NoticesListContextProvider>
  );
};

export default NoticesListScreen;
export const routeName: string = "/notices";
